import { Box, FormControl, OutlinedInput, Tooltip, Typography, useTheme } from '@mui/material'

import LinkedinSvg from './icons/linkedin.svg'
import MetaBlueSvg from './icons/meta_1.svg'
import SnapchatSvg from './icons/snapchat.svg'
import InstagramSvg from './icons/social.svg'
import SpotifySvg from './icons/spotify.svg'
import TikTokSvg from './icons/tiktok.svg'
import TwitterSvg from './icons/twitter.svg'
import YouTubeSvg from './icons/youtube.svg'

export const determineSocialIcons = icon => {
  switch (icon) {
    case 'facebook':
      return MetaBlueSvg
    case 'instagram':
      return InstagramSvg
    case 'linkedin':
      return LinkedinSvg
    case 'spotify':
      return SpotifySvg
    case 'twitter':
      return TwitterSvg
    case 'youtube':
      return YouTubeSvg
    case 'tiktok':
      return TikTokSvg
    case 'snapchat':
      return SnapchatSvg
    default:
      return null
  }
}

const SvgIconComponent = ({ socialProfiles = [], isReadOnlyRender }) => {
  const theme = useTheme()

  return (
    <FormControl
      fullWidth
      variant={isReadOnlyRender ? 'standard' : 'outlined'}
      disabled
      sx={{
        mt: 1.65, // vertical margin to match MUI TextField
      }}
    >
      <OutlinedInput
        readOnly
        sx={{
          bgcolor: 'background.section',
          borderRadius: 1,
          minHeight: '45px',
          display: 'flex',
          alignItems: 'center',
          pl: 1.5,
          pr: 1.5,
          gap: 1,
          // backgroundColor: theme.palette.background.paper,
          '& .MuiOutlinedInput-notchedOutline': {
            border: isReadOnlyRender ? 'none' : '',
            borderColor: theme.palette.divider,
          },
          '&.Mui-disabled': {
            WebkitTextFillColor: isReadOnlyRender ? '' : theme.palette.text.primary,
            // bgcolor: isReadOnlyRender ? theme.palette.background.section : '',
            bgcolor: isReadOnlyRender ? 'transparent' : '',
          },
        }}
        inputProps={{
          style: {
            padding: 0,
            display: 'flex',
            alignItems: 'center',
          },
        }}
        startAdornment={
          socialProfiles.length > 0 ? (
            <Box display="flex" gap={1}>
              {socialProfiles.map((profile, index) => {
                const Icon = determineSocialIcons(profile.network)
                if (!Icon) return null

                return (
                  <Tooltip key={`${index}-${profile.profile}`} title={profile.profile}>
                    <a
                      href={profile.url?.startsWith('http') ? profile.url : `https://${profile.url}`}
                      onClick={e => e.stopPropagation()}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <img
                        src={Icon}
                        alt={profile.network}
                        width="24"
                        height="24"
                        style={{
                          borderRadius: '4px',
                          cursor: 'pointer',
                          opacity: 0.9,
                        }}
                      />
                    </a>
                  </Tooltip>
                )
              })}
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No social profiles linked
            </Typography>
          )
        }
      />
    </FormControl>
  )
}

export default SvgIconComponent
